// import 'babel-polyfill'

import Vue from 'vue'
import { mapGetters } from 'vuex'
import underscore from 'vue-underscore'
import Vuelidate from 'vuelidate'
import App from './App'
import router from './router'
import store from './store'
import DateFilter from './filters/date'
import TimeFilter from './filters/time'
import CurrencyFilter from './filters/currency'
import DebtWheel from '@/mixins/DebtWheel'
import FadeTransition from '@/transitions/FadeTransition.vue'
import VueQrcodeReader from 'vue-qrcode-reader'
import vuetify from './plugins/vuetify'
import i18n from './plugins/i18n'
import VueMatomo from 'vue-matomo'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'typeface-montserrat'
import '@fortawesome/fontawesome-free/css/all.css'

import '@/scss/main.scss'

Vue.filter('formatDate', DateFilter)
Vue.filter('formatTime', TimeFilter)
Vue.filter('currency', CurrencyFilter)

Vue.component('debt-wheel', DebtWheel)
Vue.component('fade-transition', FadeTransition)

Vue.use(Vuelidate)
Vue.use(underscore)
Vue.use(VueQrcodeReader)

Vue.use(VueMatomo, {
  host: 'https://okperinta.matomo.cloud',
  siteId: process.env.VUE_APP_CONFIG_ENV === 'production' ? 1 : 2,
  trackerFileName: 'matomo',
  router: router
});

Vue.mixin({
  methods: {
    tabPageEvent (val) {
      if (val && val !== 'undefined') {
        this.$matomo && this.$matomo.trackEvent("Tabs", "Tab change", val)
      }
    }
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  vuetify,
  i18n,
  store,
  render: h => h(App),
  created () {
    this.$i18n.locale = this.locale
    window._paq.push(['setCustomDimension', 1, this.locale])
    window._paq.push(['HeatmapSessionRecording::disable'])

    this.$store.dispatch('autoLogin')
    if (this.cookiesAllowed) {
      window._paq.push(['rememberCookieConsentGiven'])
    } else {
      window._paq.push(['requireCookieConsent'])
    }

    if (this.trackingAllowed && Object.prototype.hasOwnProperty.call(this.debtor, 'nr')) {
      window._paq.push(['setUserId', this.debtor.nr])
    }

    if (this.trackingAllowed) {
      window._paq.push(['HeatmapSessionRecording::enable'])
    }
  },
  computed: mapGetters({
    locale: 'locale',
    cookiesAllowed: 'cookiesAllowed',
    trackingAllowed: 'trackingAllowed',
    debtor: 'debtor'
  }),
  watch: {
    locale: function (val) {
      this.$i18n.locale = val
      window._paq.push(['setCustomDimension', 1, val])
    },
    cookiesAllowed: function (val) {
      if (val) {
        window._paq.push(['setCookieConsentGiven'])
      } else {
        window._paq.push(['forgetCookieConsentGiven'])
      }
    },
    trackingAllowed: function (val) {
      if (val) {
        window._paq.push(['HeatmapSessionRecording::enable'])
      } else if (val && Object.prototype.hasOwnProperty.call(this.debtor, 'nr')) {
        window._paq.push(['setUserId', this.debtor.nr])
      } else if (!val) {
        window._paq.push(['HeatmapSessionRecording::disable'])
        window._paq.push(['resetUserId'])
        window._paq.push(['appendToTrackingUrl', 'new_visit=1']);
        window._paq.push(['trackEvent', 'Action', 'Reset UserNr', 'Reset UserNr'])
        window._paq.push(['appendToTrackingUrl', ''])
      }
    }
  }
}).$mount('#app')
